<app-pcbread-crumb [data]="'Sale,SaleCosmetic'"></app-pcbread-crumb>

<app-warehouse-handling-modal
  [modalIsOpen]="modalWarehouseIsOpen"
  [data]="thisItemOnStock"
  (parentActionOutput)="parentAction($event)"
>
</app-warehouse-handling-modal>

<div
  id="addCard"
  class="card mb-4 stock-card animate__animated animate__backInDown"
  *ngIf="level == 2 || level == 1"
>
  <div class="card-body p-0">
    <div class="row p-0 m-0">
      <div
        class="d-flex justify-content-start align-items-start p-1 col-sm-6 order-sm-1 col-6 order-1"
      >
        <p class="mobile-size m-0">{{ "SaleCosmetic" | translate }}</p>
      </div>

      <div
        class="d-flex justify-content-end align-items-start p-1 col-sm-6 order-sm-3 col-6 order-2"
      >
        <button
          type="button"
          class="btn btn-icon btn-outline-primary"
          placement="bottom"
          (click)="parentAction(settingModal)"
          ngbTooltip="{{ 'Settings' | translate }}"
        >
          <span class="bx bx-cog"></span>
        </button>
        <button
          type="button"
          class="btn btn-icon btn-outline-primary ms-1"
          placement="bottom"
          [routerLink]="['/ElectronicPrescription']"
          ngbTooltip="{{ 'ElectronicPrescription' | translate }}"
        >
          <span class="fa-solid fa-prescription"></span>
        </button>
        <button
          type="button"
          class="btn btn-icon btn-outline-primary ms-1"
          placement="bottom"
          [routerLink]="['/SaleReport']"
          ngbTooltip="{{ 'SaleReport' | translate }}"
        >
          <span class="tf-icons bx bx-list-check"></span>
        </button>
        <button
          type="button"
          class="btn btn-icon btn-outline-primary ms-1"
          placement="bottom"
          (click)="print()"
          ngbTooltip="{{ 'Print' | translate }}"
          id="print.id"
        >
          <span class="tf-icons bx bx-printer"></span>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card-body-box d-flex">
          <div class="prescription-box" [ngClass]="sideBoxClass">
            <div class="row p-1 m-0 drug-list" style="width: 100%">
              <div class="mvc-grid-table">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th scope="col">{{ "Row" | translate }}</th>
                        <th scope="col">{{ "drugBrandName" | translate }}</th>
                        <th scope="col">{{ "sellPrice" | translate }}</th>
                        <th scope="col">{{ "count" | translate }}</th>
                        <th scope="col">{{ "Insurance" | translate }}</th>
                        <th scope="col">{{ "paidPrice" | translate }}</th>
                        <th scope="col">{{ "TotalAmount" | translate }}</th>
                        <th scope="col">{{ " " | translate }}</th>
                      </tr>
                    </thead>
                    <tbody id="rows">
                      <tr *ngFor="let selectDrug of factorItems; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ selectDrug.brandName | dataType : "" }}</td>
                        <td>
                          {{
                            selectDrug.inventoryDetailSelect!.sellPrice
                              | dataType : "price"
                          }}
                        </td>
                        <td>{{ selectDrug.count }}</td>
                        <td>
                          {{ selectDrug.insurancePrice | dataType : "price" }}
                        </td>
                        <td>{{ selectDrug.paidPrice | dataType : "price" }}</td>
                        <td>
                          {{ selectDrug.elementPrice | dataType : "price" }}
                        </td>

                        <td>
                          <div
                            class="d-flex justify-content-center align-items-center"
                          >
                            <button
                              type="button"
                              class="delete-icon-on-table btn btn-icon btn-outline-danger me-1"
                              (click)="remove(i)"
                              ngbTooltip="{{ 'Delete' | translate }}"
                            >
                              <i class="fa-regular fa-trash-can"></i>
                            </button>
                            <button
                              (click)="UidScanner(selectDrug)"
                              class="btn-outline-primary btn btn-icon me-1"
                              ngbTooltip="{{ 'ScanBarcode' | translate }}"
                            >
                              <i class="fa-solid fa-barcode"></i>
                            </button>
                            <button
                              (click)="EditItem(selectDrug, i)"
                              class="btn-outline-primary btn btn-icon"
                              ngbTooltip="{{ 'Edit' | translate }}"
                            >
                              <i class="far fa-edit"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div id="add-box" class="row p-2 mx-1 mb-3 mt-2 add-box-item">
                  <div class="col-12 mb-2">
                    <div class="total-box position-relative">
                      <span class="p-2">
                        {{ "Inventory" | translate }} :
                        {{ editableItem.totalCount | number }}
                      </span>

                      <button
                        type="button"
                        class="span-button p-2"
                        (click)="openModal(Inventory)"
                      >
                        {{ "ActiveInventory" | translate }} :
                        {{ editableItem.inventory | number }}
                      </button>

                      <span
                        *ngIf="tosale"
                        class="p-2 border-sale position-relative"
                      >
                        {{ "SalesPrice" | translate }} :
                        {{
                          editableItem.inventoryDetailSelect?.sellPrice == null
                            ? 0
                            : (editableItem.inventoryDetailSelect?.sellPrice
                              | number)
                        }}
                        {{ "Rial" | translate }}
                        <button (click)="EditPrice()" class="icon-sale">
                          <i class="fa-solid fa-pen-to-square"></i>
                        </button>
                      </span>

                      <div class="border-sale" *ngIf="!tosale">
                        <input
                          class="p-2 form-control form-set"
                          type="text"
                          [(ngModel)]="backendJsonChange.newPrice"
                          (keyup.Enter)="SaveEditPrice()"
                          placeholder="مبلغ مورد نظر را وارد کنید"
                          mask="separator.0"
                          thousandSeparator=","
                        />

                        <button
                          class="icon-sale-position btn btn-icon btn-primary"
                          (click)="SaveEditPrice()"
                        >
                          <i class="fa-solid fa-check"></i>
                        </button>
                        <app-loading-panel
                          *ngIf="changePriceLoading"
                        ></app-loading-panel>
                      </div>

                      <span class="p-2">
                        {{ "SumTotal" | translate }} :
                        {{ editableItem.paidPrice | number }}
                        {{ "Rial" | translate }}
                      </span>
                    </div>
                  </div>

                  <div class="col-12 col-xxl-5 mb-3">
                    <div
                      class="edit-form"
                      appClickOutside
                      (clickOutside)="modalIsOpen = false"
                    >
                      <label class="form-label" for="DrugGenricName">
                        {{ "AdvancedSearch" | translate }}
                      </label>
                      <div class="validation-alert-sale-buy">
                        <p>{{ itemValidation.drugNameMessage }}</p>
                      </div>

                      <form [formGroup]="drugSearchForm">
                        <div
                          class="input-group input-box-search-advance row ms-1 p-0 w-100"
                        >
                         
                          <div class="col-11 p-0">
                            <input
                              id="drugBrandName"
                              type="text"
                              autocomplete="off"
                              appSelectOnFocus
                              formControlName="drugBrandName"
                              class="form-control Focusable iner-Focusable search-input-box"
                              placeholder="{{
                                'SearchAndScanBarcode' | translate
                              }}"
                              [(ngModel)]="editableItem.brandPersianName"
                              [ngClass]="{
                                'is-invalid':
                                  itemValidation.drugNameMessage != '' &&
                                  itemValidation.drugNameMessage != null
                              }"
                              (keyup.escape)="modalIsOpen = false"
                            />
                          </div>

                          <div class="col-1 p-0">
                            <button
                              class="btn btn-outline-primary w-100 px-0"
                              type="button"
                              ngbTooltip="{{ 'ScanBarcode' | translate }}"
                              (click)="openCamera()"
                            >
                              <i class="bx bx-barcode-reader"></i>
                            </button>
                          </div>
                        </div>
                      </form>
                      <app-search-box
                        [data]="searchData"
                        [addButton]="false"
                        [fields]="searchFields"
                        [urlName]="'columnsArray_saleCosmeticSearch'"
                        [paging]="searchPaging"
                        [modalIsOpen]="modalIsOpen"
                        (parentAction)="parentSearchAction($event)"
                      ></app-search-box>
                    </div>
                  </div>

                  <div class="col-12 col-xxl-4 col-xl-12 mb-3">
                    <div class="edit-form row drugcount-status">
                      <div class="validation-alert-count-sale-buy">
                        <p>{{ itemValidation.countMessage }}</p>
                      </div>

                      <div
                        class="p-xxl-0 ps-xxl-0 p-xl-0 ps-xl-3 p-md-0 ps-md-3 p-xs-0 p-2 col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-5"
                      >
                        <label class="form-label" for="Number">
                          {{ "packageCount" | translate }}
                        </label>
                        <input
                          #count
                          id="packageCount"
                          type="text"
                          autocomplete="off"
                          appSelectOnFocus
                          class="form-control input-one Focusable iner-Focusable"
                          [ngClass]="{
                            'is-invalid':
                              itemValidation.countMessage != '' &&
                              itemValidation.countMessage != null
                          }"
                          [(ngModel)]="editableItem.packageCount"
                          (keyup)="calcRow()"
                          mask="separator.0"
                          thousandSeparator=","
                        />
                      </div>

                      <div class="col-1 p-0 icon-size mt-4 drugpackage-status">
                        <label class="form-label label-one">
                          <i class="fa-solid fa-xmark"></i>
                        </label>
                      </div>
                      <div
                        class="p-xxl-0 ps-xxl-0 p-xl-0 p-md-0 p-xs-0 p-2 col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-5"
                      >
                        <label class="form-label" for="Number">
                          {{ "drugPackage" | translate }}
                        </label>
                        <input
                          id="DrugPackage"
                          type="text"
                          appSelectOnFocus
                          (keyup)="calcRow()"
                          autocomplete="off"
                          class="form-control input-one Focusable iner-Focusable"
                          [ngClass]="{
                            'is-invalid':
                              itemValidation.countMessage != '' &&
                              itemValidation.countMessage != null
                          }"
                          [(ngModel)]="editableItem.drugPackageCount"
                          mask="separator.0"
                          thousandSeparator=","
                        />
                      </div>
                      <div class="col-1 p-0 icon-size mt-4">
                        <label class="form-label label-two col-3">
                          <i class="fa-solid fa-equals"></i>
                        </label>
                      </div>
                      <div
                        class="p-xxl-0 ps-xxl-0 pe-xxl-3 p-xl-0 pe-md-3 p-md-0 p-xs-0 p-2 col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-12"
                      >
                        <label class="form-label" for="Number">
                          {{ "Number" | translate }}
                        </label>
                        <input
                          #count
                          id="Number"
                          type="text"
                          autocomplete="off"
                          appSelectOnFocus
                          class="form-control Focusable iner-Focusable"
                          [ngClass]="{
                            'is-invalid':
                              itemValidation.countMessage != '' &&
                              itemValidation.countMessage != null
                          }"
                          [(ngModel)]="editableItem.count"
                          (ngModelChange)="calcFactor()"
                          mask="separator.0"
                          thousandSeparator=","
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-xxl-3">
                    <div class="edit-form">
                      <label class="form-label">
                        {{ "ExpireDate" | translate }}
                      </label>
                      <span class="input-form-control">
                        {{
                          editableItem.inventoryDetailSelect?.expireDate
                            | dataType : ""
                        }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="col-12 col-md-6 mb-3"
                    [ngClass]="
                      backendJson.insurance == 'OTC' ||
                      backendJson.insurance == 'PSC'
                        ? 'col-xl-6 col-xxl-6'
                        : 'col-xl-4 col-xxl-3'
                    "
                  >
                    <div class="edit-form">
                      <label class="form-label" for="DiscountPercent">
                        {{ "DiscountPercent" | translate }}
                      </label>
                      <input
                        type="text"
                        id="DiscountPercent"
                        class="form-control"
                        (keyup)="calcDiscount(true)"
                        [(ngModel)]="editableItem.discountPercent"
                        #discountPercent
                        mask="separator.0"
                        thousandSeparator=","
                      />
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-6 mb-3"
                    [ngClass]="
                      backendJson.insurance == 'OTC' ||
                      backendJson.insurance == 'PSC'
                        ? 'col-xl-6 col-xxl-6'
                        : 'col-xl-4 col-xxl-3'
                    "
                  >
                    <div class="edit-form">
                      <label class="form-label" for="Discount">
                        {{ "Discount" | translate }}
                      </label>
                      <input
                        type="text"
                        id="Discount"
                        class="form-control"
                        (keyup)="calcDiscount(false)"
                        [(ngModel)]="editableItem.discount"
                        #Discount
                        mask="separator.0"
                        thousandSeparator=","
                      />
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-6 col-xl-4 col-xxl-3 mb-3"
                    *ngIf="
                      backendJson.insurance != 'OTC' &&
                      backendJson.insurance != 'PSC'
                    "
                  >
                    <div class="edit-form">
                      <label class="form-label" for="InsurancePrice">
                        {{ "InsurancePrice" | translate }}
                      </label>
                      <input
                        type="text"
                        id="InsurancePrice"
                        class="form-control"
                        (keyup)="calcFactor()"
                        [(ngModel)]="editableItem.insurancePrice"
                        #Discount
                        mask="separator.0"
                        thousandSeparator=","
                      />
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-6 col-xl-4 col-xxl-3 mb-3"
                    *ngIf="
                      backendJson.insurance != 'OTC' &&
                      backendJson.insurance != 'PSC'
                    "
                  >
                    <div class="edit-form">
                      <label class="form-label" for="ShareCurrencyPrice">
                        {{ "ShareCurrencyPrice" | translate }}
                      </label>
                      <input
                        type="text"
                        id="ShareCurrencyPrice"
                        class="form-control"
                        (keyup)="calcFactor()"
                        [(ngModel)]="editableItem.shareCurrencyPrice"
                        #Discount
                        mask="separator.0"
                        thousandSeparator=","
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <hr />
                  </div>
                  <div class="col-12 d-flex justify-content-end">
                    <button
                      type="button"
                      class="btn btn-primary"
                      id="save-button"
                      (click)="confirmNewItem()"
                    >
                      <i class="far fa-save"></i>
                      {{ "Save" | translate }}
                    </button>
                    <button
                      type="button"
                      id="clear-button"
                      class="btn btn-light ms-2"
                      (click)="clearNewItem()"
                    >
                      <i class="fas fa-eraser"></i>
                      {{ "Clear" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <app-loading-panel *ngIf="loading"></app-loading-panel>
          </div>

          <div
            class="side-box-body d-flex align-items-center"
            [ngClass]="sideBoxClass"
          >
            <div class="side-box side-box-shadow-border position-relative">
              <!-- <div class="side-box-close-button-box" [ngClass]="sideBoxClass">
                <button type="button" (click)="changeSideBoxState()">
                  <i
                    class="bx"
                    [ngClass]="{
                      'bxs-chevron-left':
                        sideBoxClass == 'side-box-open' ||
                        sideBoxClass == 'side-box-try-open',
                      'bxs-chevron-right':
                        sideBoxClass == 'side-box-close' ||
                        sideBoxClass == 'side-box-try-close'
                    }"
                  ></i>
                </button>
              </div> -->
              <div class="row dark-theme">
                <div class="col-12">
                  <div class="side-box-header py-1">
                    <h6 class="m-0">
                      {{ "CustomerCheckout" | translate }}
                    </h6>
                  </div>
                </div>
                <div class="col-12 mt-2">
                  <div class="side-box-key-value mx-2">
                    <label for="">
                      {{ "SumItems" | translate }}
                    </label>
                    <p class="m-0">
                      {{ backendJson.elementPrice | dataType : "price" }}
                    </p>
                  </div>
                </div>
                <div class="col-12">
                  <div class="side-box-key-value mx-2">
                    <label for="technicalRight">
                      {{ "technicalRight" | translate }}
                    </label>
                    <div class="input-currency-box">
                      <input
                        id="insuranceTechnicalRight"
                        type="text"
                        class="form-control"
                        [(ngModel)]="backendJson.technicalRight"
                        (keyup)="allFactor()"
                        mask="separator.0"
                        thousandSeparator=","
                      />
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <hr class="my-1" />
                </div>
                <div class="col-12 mb-2">
                  <div class="side-box-key-value mx-2">
                    <label for="">
                      {{ "SumPsc" | translate }}
                    </label>
                    <p class="m-0">
                      {{ backendJson.prescriptionPrice | dataType : "price" }}
                    </p>
                  </div>
                </div>
                <div class="col-12 dark-theme mt-2"
                  *ngIf="
                    backendJson.insurance != 'OTC' &&
                    backendJson.insurance != 'PSC'
                  "
                >
                  <div class="side-box-key-value mx-2">
                    <label for="">
                      {{ "InsuranceShare" | translate }}
                    </label>
                    <p class="m-0">
                      {{ backendJson.insurancePrice | dataType : "price" }}
                    </p>
                  </div>
                </div>

                <div
                  class="col-12"
                  *ngIf="
                    backendJson.insurance != 'OTC' &&
                    backendJson.insurance != 'PSC'
                  "
                >
                  <div class="side-box-key-value mx-2">
                    <label for="insuranceTechnicalRight">
                      {{ "insuranceTechnicalRight" | translate }}
                    </label>
                    <div class="input-currency-box">
                      <input
                        id="insuranceTechnicalRight"
                        type="text"
                        class="form-control"
                        [(ngModel)]="backendJson.insuranceTechnicalRight"
                        (keyup)="allFactor()"
                        mask="separator.0"
                        thousandSeparator=","
                      />

                      <p>ریال</p>
                    </div>
                  </div>
                </div>

                <div
                  class="col-12"
                  *ngIf="
                    backendJson.insurance != 'OTC' &&
                    backendJson.insurance != 'PSC'
                  "
                >
                  <div class="side-box-key-value mx-2">
                    <label for="">
                      {{ "ShareCurrencyPrice" | translate }}
                    </label>
                    <p class="m-0">
                      {{ backendJson.shareCurrencyPrice | dataType : "price" }}
                    </p>
                  </div>
                </div>

                <div
                  class="col-12"
                  *ngIf="
                    backendJson.insurance != 'OTC' &&
                    backendJson.insurance != 'PSC'
                  "
                >
                  <hr class="my-1" />
                </div>
                <div
                  class="col-12 mb-2"
                  *ngIf="
                    backendJson.insurance != 'OTC' &&
                    backendJson.insurance != 'PSC'
                  "
                >
                  <div class="side-box-key-value mx-2">
                    <label for="">
                      {{ "SumInsurance" | translate }}
                    </label>
                    <p class="m-0">
                      {{ backendJson.totalInsurance | dataType : "price" }}
                    </p>
                  </div>
                </div>

                <div class="col-12 my-2">
                  <div class="side-box-key-value mx-2">
                    <label for="">
                      {{ "Payable" | translate }}
                    </label>
                    <p class="m-0">
                      {{ backendJson.paidPrice | dataType : "price" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #ScanBarcodeModal let-modal class="modal modal-top fade">
    <app-scan-barcode-modal
      [itemCount]="selectValue.packageCount"
      [barcodeList]="selectValue.drugUIds"
      (parentActionOutput)="parentAction($event)"
    ></app-scan-barcode-modal>
  </ng-template>

  <app-pcsetting-modal
    (parentAction)="parentAction($event)"
    [fields]="searchFields"
  >
  </app-pcsetting-modal>

  <app-sale-print-factor
    [modalIsOpen]="receptModalIsOpen"
    [recept]="recept"
    (parentAction)="parentAction($event)"
  ></app-sale-print-factor>

  <ng-template #PatientInformation let-modal class="modal modal-top fade">
    <div class="modal-header border-bottom p-3">
      <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
        {{ "PatientInformation" | translate }}
      </h6>
      <button
        type="button"
        class="btn-close-modal btn-icon btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-label="Close"
      ></button>
    </div>

    <div class="modal-body border-bottom">
      <div class="row">
        <div class="col-12">
          <div class="information-box p-2 m-2 patient-information-box">
            <div class="row">
              <div class="col-12 col-xxl-3 col-md-4 top-input-box">
                <label for="PatientFirstName" class="form-label pt-2"
                  >{{ "PatientFirstName" | translate }}:</label
                >
                <input
                  id="PatientFirstName"
                  type="text"
                  class="form-control"
                  placeholder="{{ 'EnterPatientFirstName' | translate }}"
                  [(ngModel)]="backendJson.patientFirstName"
                  (keyup)="
                    backendJson.patientFirstName = numericService.checkJustWord(
                      backendJson.patientFirstName
                    )
                  "
                />
              </div>
              <div class="col-12 col-xxl-3 col-md-4 top-input-box">
                <label for="PatientLastName" class="form-label pt-2"
                  >{{ "PatientLastName" | translate }}:</label
                >
                <input
                  id="PatientLastName"
                  type="text"
                  class="form-control"
                  placeholder="{{ 'EnterPatientLastName' | translate }}"
                  [(ngModel)]="backendJson.patientLastName"
                  (keyup)="
                    backendJson.patientLastName = numericService.checkJustWord(
                      backendJson.patientLastName
                    )
                  "
                />
              </div>
              <div class="col-12 col-xxl-3 col-md-4 top-input-box">
                <label for="PatientNationalCode" class="form-label pt-2"
                  >{{ "PatientNationalCode" | translate }}:</label
                >
                <input
                  id="PatientNationalCode"
                  type="text"
                  class="form-control"
                  placeholder="{{ 'EnterPatientNationalCode' | translate }}"
                  maxlength="10"
                  [(ngModel)]="backendJson.patientNationalCode"
                  (keyup)="
                    backendJson.patientNationalCode =
                      numericService.checkNumber(
                        backendJson.patientNationalCode
                      )
                  "
                />
              </div>
              <div class="col-12 col-xxl-3 col-md-4 top-input-box">
                <label for="patientBirthDate" class="form-label pt-2"
                  >{{ "PatientBirthDate" | translate }}:</label
                >
                <div class="datepicker-box">
                  <input
                    type="text"
                    class="form-control Focusable"
                    autocomplete="off"
                    id="birthDate"
                    appSelectOnFocus
                    [ngModel]="backendJson.birthDate | dataType : '' : false"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="YYYY/MM/DD"
                    (ngModelChange)="patientBirthDate()"
                  />
                  <button
                    [ngbPopover]="popoverDatapickerdeliverydata"
                    [autoClose]="'outside'"
                    #datePicker="ngbPopover"
                  >
                    <i class="far fa-calendar-alt"></i>
                  </button>
                </div>
                <ng-template #popoverDatapickerdeliverydata>
                  <app-data-picker
                    [(childProp)]="backendJson.birthDate"
                    (changeVariableMonth)="changeMonth($event)"
                  ></app-data-picker>
                </ng-template>
              </div>

              <div class="col-12 col-xxl-3 col-md-4 top-input-box">
                <label for="PatientMobileNumber" class="form-label pt-2"
                  >{{ "PatientPhone" | translate }}:</label
                >
                <input
                  id="PatientMobileNumber"
                  type="text"
                  class="form-control"
                  placeholder="{{ 'EnterPatientPhone' | translate }}"
                  [(ngModel)]="backendJson.patientMobileNumber"
                  (keyup)="
                    backendJson.patientMobileNumber =
                      numericService.checkNumber(
                        backendJson.patientMobileNumber
                      )
                  "
                />
              </div>
              <div class="col-12 col-xxl-3 col-md-4 top-input-box">
                <label for="SerialInsurance" class="form-label pt-2"
                  >{{ "SerialInsurance" | translate }}:</label
                >
                <input
                  id="SerialInsurance"
                  type="text"
                  class="form-control"
                  placeholder="{{ 'EnterSerialInsurance' | translate }}"
                  [(ngModel)]="backendJson.serialInsurance"
                />
              </div>
              <div class="col-12 col-xxl-3 col-md-4 top-input-box">
                <label for="insuranceBookPage" class="form-label pt-2"
                  >{{ "insuranceBookPage" | translate }}:</label
                >
                <input
                  id="insuranceBookPage"
                  type="text"
                  class="form-control"
                  placeholder="{{ 'EnterInsuranceBookPage' | translate }}"
                  [(ngModel)]="backendJson.insuranceBookPage"
                />
              </div>
              <div class="col-12 col-xxl-3 col-md-4 top-input-box">
                <label for="PersonnelId" class="form-label pt-2"
                  >{{ "PersonnelId" | translate }}:</label
                >
                <input
                  id="PersonnelId"
                  type="text"
                  class="form-control"
                  placeholder="{{ 'EnterPersonnelId' | translate }}"
                  [(ngModel)]="backendJson.employeeNumber"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="information-box p-2 m-2 doctor-information-box">
            <div class="row">
              <div class="col-12 col-xxl-3 col-md-4 top-input-box">
                <label for="DoctorFirstName" class="form-label pt-2"
                  >{{ "DoctorFirstName" | translate }}:</label
                >
                <input
                  id="DoctorFirstName"
                  type="text"
                  class="form-control"
                  placeholder="{{ 'EnterDoctorFirstName' | translate }}"
                  [(ngModel)]="backendJson.doctorFirstName"
                  (keyup)="
                    backendJson.doctorFirstName = numericService.checkJustWord(
                      backendJson.doctorFirstName
                    )
                  "
                />
              </div>
              <div class="col-12 col-xxl-3 col-md-4 top-input-box">
                <label for="DoctorLastName" class="form-label pt-2"
                  >{{ "DoctorLastName" | translate }}:</label
                >
                <input
                  id="DoctorLastName"
                  type="text"
                  class="form-control"
                  placeholder="{{ 'EnterDoctorLastName' | translate }}"
                  [(ngModel)]="backendJson.doctorLastName"
                  (keyup)="
                    backendJson.doctorLastName = numericService.checkJustWord(
                      backendJson.doctorLastName
                    )
                  "
                />
              </div>
              <div class="col-12 col-xxl-3 col-md-4 top-input-box">
                <label for="medicalsystemcode" class="form-label pt-2"
                  >{{ "Medicalsystemcode" | translate }}:</label
                >
                <input
                  id="medicalsystemcode"
                  type="text"
                  class="form-control"
                  placeholder="{{ 'EnterMedicalsystemcode' | translate }}"
                  [(ngModel)]="backendJson.doctorCode"
                  (keyup)="
                    backendJson.doctorCode = numericService.checkNumber(
                      backendJson.doctorCode
                    )
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer justify-content-center p-2">
      <button
        type="button"
        class="btn btn-light"
        (click)="modal.dismiss('Cross click')"
      >
        <i class="bx bx-x"></i>
        {{ "Close" | translate }}
      </button>
    </div>
  </ng-template>
</div>

<ng-template #Inventory let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "InventoryInformation" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body border-bottom">
    <div class="row">
      <div class="col-12">
        <div class="stock-detail">
          <table class="table datatables-ajax">
            <thead class="table-header-dark-light">
              <tr class="cdk-drop-list table-light">
                <th scope="col">{{ "Stock" | translate }}</th>
                <th scope="col">{{ "Number" | translate }}</th>
                <th scope="col">
                  {{ "expierDate" | translate }}
                </th>
                <th scope="col">
                  {{ "sellPrice" | translate }}
                </th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="table-body-dark-light">
              <tr
                class="position-relative"
                *ngFor="
                  let item of editableItem.inventoryDetails;
                  let i = index
                "
              >
                <td>{{ item.stockName }}</td>
                <td>{{ item.count | dataType : "" }}</td>
                <td>{{ item.expireDate | dataType : "" }}</td>
                <td>{{ item.sellPrice | dataType : "price" }}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-icon btn-outline-primary"
                    (click)="changeInventorySelect(item)"
                  >
                    <i class="bx bxs-hand"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer justify-content-center p-2">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.dismiss('Cross click')"
    >
      <i class="bx bx-x"></i>
      {{ "Close" | translate }}
    </button>
  </div>
</ng-template>
<app-barcode-scanner
  #barcodeScanner
  (parentAction)="handleScannedBarcode($event)"
></app-barcode-scanner>